import { connect } from 'react-redux'
import Action from './action'
import { getContribution } from '../../../../stores/discussion/discussion.selectors'

const mapStateToProps = (state, { id }) => {
  const action = getContribution(state, id)
  return {
    id,
    type: action.type
  }
}

export default connect(
  mapStateToProps,
  null
)(Action)
